import { Typography } from "@material-ui/core";
import * as React from "react";
import Collapse from "@material-ui/core/Collapse";
import ChatLogo from "../../../../icons/wbi-logo-v2-primary.svg";
import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";

const defaultBubbleStyles = {
  userBubble: {},
  chatbubble: {},
  text: {},
};

class CustomBubble extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldCollapse: true,
    };
  }
  updateCollapse = () => {
    this.setState({ shouldCollapse: false });
  };

  componentDidMount() {
    // collapse after the fade happens
    const messageEl = document.getElementById(
      `${this.props.message.message}-${this.props.message.messageId}-${this.props.message.treeStep}`
    );
    messageEl.addEventListener("transitionend", () => this.updateCollapse());
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.treeStep === null && prevState.shouldCollapse === false) {
      this.setState({ shouldCollapse: true });
    }
  }

  render() {
    const {
      message,
      onClick,
      groupCollapse,
      prevMessages,
      treeStep,
      creatingTicket,
    } = this.props;
    const { shouldCollapse } = this.state;

    let { bubbleStyles, classes: styles } = this.props;

    bubbleStyles = bubbleStyles || defaultBubbleStyles;
    const { userBubble, chatbubble } = bubbleStyles;

    // message.id 0 is reserved for the user
    const chatBubbleStyles =
      this.props.message.userId === 0
        ? [
          styles.chatbubble,
          styles.chatbubbleOrientationNormal,
          (message.selected ? styles.isSelected : ''),
          chatbubble,
          userBubble,
          styles.bubbles
        ]
        : [
          styles.chatbubble,
          styles.recipientChatbubble,
          styles.recipientChatbubbleOrientationNormal,
          userBubble,
          chatbubble,
          styles.bubbles
        ];
    // fade when its the next step and not the same path
    // fade when next step and same path

    const hasPrevMessage = prevMessages.includes(message);

    // only add fade, if not first default messasge
    // not selected
    // in the old messages
    // already faded

    const chatbubbleWrapperStyles =
      this.props.message.userId === 0
        ? [
          styles.chatbubbleWrapper,
          styles.chatbubbleOrientationNormal,
          (treeStep === null ?
            '':
            message.selected ?
              '':
              !groupCollapse ?
                styles.fade:
                hasPrevMessage && !message.selected ?
                  styles.fade:
                  ''
            ),
        ]
        : [
          styles.chatbubbleWrapper,
          styles.recipientChatbubbleOrientationNormal,
        ];

    return (
      <Collapse in={shouldCollapse && groupCollapse}>
        <div
          className={chatbubbleWrapperStyles.join(' ')}
          id={`${message.message}-${message.messageId}-${message.treeStep}`}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {message.userId === 1 && <img src={ChatLogo} alt="cy logo" style={{width: 50, paddingLeft: 10}}/>}
          </div>
          <div className={chatBubbleStyles.join(' ')}>
            {
              creatingTicket || message.userId === 1 || hasPrevMessage ?
                <Typography variant="body2">{message.message}</Typography> :
                <button
                  value={message.message}
                  onClick={(e) => onClick(e, message)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "inherit",
                    padding: "0",
                    font: "inherit",
                    cursor: "pointer",
                    textAlign: "left",
                    outline: "inherit",
                  }}
                >
                  <Typography variant="body2">{`${message.message}`}</Typography>
                </button>
            }
          </div>
        </div>
      </Collapse>
    );
  }
}
export default withStyles(styles)(CustomBubble);


// WEBPACK FOOTER //
// ./src/components/HelpWidget/components/ChatBubble/index.jsx